import Vue from "vue";
import DrivingTest from "./components/DrivingTest.vue";

Vue.config.productionTip = true;

new Vue({
  render: h => h(DrivingTest)
}).$mount("#driving-test");
